import { useApp } from '@/store/AppContext'
import { KPIHeader } from '@/components/dashboard/KPIHeader'
import { CheckInForm } from '@/components/tickets/CheckInForm'
import { ActiveTickets } from '@/components/tickets/ActiveTickets'
import { ActivityLog } from '@/components/dashboard/ActivityLog'
import { cn } from '@/lib/utils'

export default function Index() {
  const { isOperationMode } = useApp()

  return (
    <div
      className={cn('space-y-6 animate-fade-in', isOperationMode && 'text-lg')}
    >
      <KPIHeader />
      <div
        className={cn(
          'grid gap-6 items-start',
          isOperationMode
            ? 'grid-cols-1'
            : 'md:grid-cols-[350px_1fr] lg:grid-cols-[400px_1fr]',
        )}
      >
        <div className="space-y-6">
          <CheckInForm />
          {!isOperationMode && <ActivityLog />}
        </div>
        <ActiveTickets />
      </div>
    </div>
  )
}
